export class ListaTarefa {
  itens: ItemTarefa[] = [];
}
export class ItemTarefa {
  id: number;
  descricao: string;
  dataCadastro: Date;
  dataPrevisaoFinalizacao: Date;
  dataInicial: Date;
  dataFinalizacao: Date;
  responsavel: string;
  tipoTarefa: string;
  processo: string;
  processoId: number;
  atendimentoId: number;
  atendimento: string;
  nova: boolean = false;
  status: number;
}
